/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {useState} from "react";
import { Helmet } from 'react-helmet-async';
import { useForm, UseFormReturn } from "react-hook-form";
import axios from 'axios';
// import history from '../history';
import '../styles/main.css';
import '../styles/Contact.css';
import MapContainer from "./MapContainer";
import Coordonates from "./Coordonates";
import { AccessTime, Contacts } from "@mui/icons-material";

type MailValues = {
  name: string;
  mail: string;
  tel: string;
  message: string;
}

const Contact = () => {
  const { handleSubmit, register, setError}: UseFormReturn = useForm({
    mode: "onChange",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingCaptcha, setIsSubmittingCaptcha] = useState(false);
  const [errorSubmitting, setErrorSubmitting] = useState(false);

  const mailServerAccess = `${process.env.REACT_APP_SERVER_MAILER}`;
  const googleMapApiKey = `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
  const recaptachaKey = `${process.env.REACT_APP_GOOGLE_RECAPTCHA}`;

  const executeCaptcha = async () => {
    await setIsSubmittingCaptcha(!isSubmittingCaptcha);
  };

  const onSubmit = async (values: MailValues) => {
    await axios({
      method:'post',
      url: `${mailServerAccess}/mail`,
      data: {
        from: values.mail,
        subject: `Demande de contact de ${values.name}`,
        text: `Adresse mail: ${values.mail}\nTéléphone: ${values.tel}\n${values.message}`,
        mail: values.mail,
        tel: values.tel,
        messageText: values.message,
      }
    })
    .then(res => {
      // console.log(res.status);
      setIsSubmitting(!isSubmitting);
    })
    .catch((error) => {
      // console.error("Error Mail:", error);
      setErrorSubmitting(true);
      setIsSubmitting(!isSubmitting);
    });
  };

  return (
    <>
      <Helmet>
        <title>Contacter Isabelle PIVET</title>
      </Helmet>
      <section className='sectionContact'>
        <section className="sectionCoordonatesContact">
          <div className="coordonatesContact">
            <div className="coordonatesContactChild">
              <div className="iconBig">
                <Contacts fontSize="large" />
              </div>
              <div className="sectionInfos">
                <h1 style={{textAlign: "left", lineHeight: 1, display: 'flex', alignItems: "center"}}>Coordonnées :</h1>
                <p style={{textAlign: "left", lineHeight: 1}}>2 Rue du Musée 38200 VIENNE</p>
                <p style={{textAlign: "left", lineHeight: 1}}>06 15 40 05 60</p>
                <p style={{textAlign: "left", lineHeight: 1}}>maitreisabellepivet@gmail.com</p>
              </div>
            </div>
            <div className="coordonatesContactChild">
              <div className="iconBig">
                <AccessTime fontSize="large" />
              </div>
              <div className="sectionInfos">
                <h1 style={{textAlign: "left", lineHeight: 1, display: 'flex', alignItems: "center"}}>Horaires d'ouverture :</h1>
                <p style={{textAlign: "left", lineHeight: 1}}>Lundi au Vendredi : 8h00 - 19h00</p>
              </div>
            </div>
          </div>
        </section>
        {/* <MapContainer apiKey={googleMapApiKey} /> */}
        <MapContainer />
      </section>
    </>
  );
};

export default Contact;
